import React from "react";
import { RegularPolygon, Wedge } from "react-konva";

import { StatsProps } from "./types";
import * as Config from "./configuration";
import { validCoordinate } from "./utils";

const REGULAR_POLYGON_RADIUS = 7;
const WEDGE_RADIUS = 12;
const STOKE_WIDTH = 1;
const ROTATION = 0;

const getColor = (result: boolean) => {
  return result ? Config.COLOR_WIN : Config.COLOR_LOSE;
};

interface IStatsTackleProps extends StatsProps {
  type?: "normal" | "sliding";
}

export const StatsTackle = ({
  from,
  result,
  type = "normal",
}: IStatsTackleProps) => {
  if (!validCoordinate(from)) {
    return null;
  }

  if (type === "sliding") {
    return (
      <Wedge
        x={from.x}
        y={from.y}
        radius={WEDGE_RADIUS}
        angle={60}
        fill={getColor(result)}
        stroke="black"
        strokeWidth={STOKE_WIDTH}
        rotation={-120}
      />
    );
  }

  return (
    <RegularPolygon
      x={from.x}
      y={from.y}
      radius={REGULAR_POLYGON_RADIUS}
      rotation={ROTATION}
      stroke="black"
      strokeWidth={STOKE_WIDTH}
      sides={3}
      fill={getColor(result)}
    />
  );
};
